import React from 'react';
import { Button, Grid, IconButton, Typography } from '@material-ui/core';
import { IoClose, IoHandLeft } from 'react-icons/io5';
import ProgressPhotosCard from '../../../../components/ProgressPhotosCard/progressPhotosCard';
import { useLang } from '../../../../util/lang';
import Moment from 'moment/moment';
import { getPhotosWithRadiographs, progress_photo_angles } from '../../../pagesUtils';
import axios from '../../../../axios-default';
import Zoom from 'react-medium-image-zoom';
import join from 'url-join';
import { ApiServerUrl } from '../../../../config.json';

const Photos = ({ caseId, handleDragStartAndEnd, photosDraggable, caseFiles }) => {
    const [progressPhotos, setProgressPhotos] = React.useState([]);

    const get = useLang('PatientInfo');

    const downloadImageFile = (file, date, type = 'image/*') => {
        axios.get(file, { responseType: 'blob' }).then(({ data }) => {
            let url = window.URL.createObjectURL(data);
            var newImageName = file.split('/')[file.split('\/').length - 1]; //using the server image name
            Object.assign(document.createElement('a'), { download: `${date}-${newImageName}`, href: url }).click();
            window.URL.revokeObjectURL(url);
        });
    };

    const downloadImages = (caseFile, type) => {
        let photosList = [],
            date = null;
        Object.entries(caseFile).map(([key, value]) => {
            if (key.includes(type) && !key.endsWith('later') && value) {
                photosList.push(join(ApiServerUrl, value));
            }
        });
        date = Moment(caseFile.created_date).format('YYYY-MM-DD');
        for (let i = 0; i < photosList.length; i++) {
            downloadImageFile(photosList[i], date);
        }
    };

    React.useEffect(() => {
        const getProgressPhotos = async () => {
            try {
                let result = await axios.get(`case/progress_photos/${caseId}`);
                setProgressPhotos(result.data.progress_photos);
            } catch (err) {
                console.error('error', err.response);
            }
            getProgressPhotos();
        };
    }, []);

    return (
        <>
            <h2
                style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    padding: '0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    marginTop: '0px',
                }}
                id="responsive-dialog-title"
            >
                <span>{get('modals.photoModalTitle')}</span>
                {photosDraggable ? (
                    <IconButton type="button" size="small" onClick={handleDragStartAndEnd}>
                        <IoClose />
                    </IconButton>
                ) : (
                    <IconButton type="button" size="small" onClick={handleDragStartAndEnd}>
                        <IoHandLeft />
                    </IconButton>
                )}
            </h2>
            <div>
                {!['INTERNATIONAL'].includes(process.env.REACT_APP_ENV) ? (
                    ''
                ) : (
                    <ProgressPhotosCard
                        progressPhotos={progressPhotos}
                        progressPhotoAngles={progress_photo_angles}
                        get={get}
                    />
                )}
                <Grid container>
                    <Grid item xs={12}>
                        {caseFiles?.map((file, index) => {
                            const photos = getPhotosWithRadiographs(file, true);

                            if (photos.length) {
                                return (
                                    <div key={`case-file-${index}`}>
                                        <div style={{ display: 'block', width: '100%' }}>
                                            {file.refinement_no ? (
                                                <Typography variant="body1">
                                                    {file.defect_resubmit_flag === true
                                                        ? `Defect Resubmit ${file.refinement_no}`
                                                        : `Refinement #${file.refinement_no}`}
                                                </Typography>
                                            ) : (
                                                <></>
                                            )}
                                            <p style={{ display: 'inline', marginRight: '15px' }}>
                                                <strong>{get('modals.uploadedAt')}</strong> :
                                                {Moment(file.created_date).format('YYYY-MM-DD HH:mm')}
                                            </p>
                                            <Button onClick={() => downloadImages(file, 'photo')} variant="outlined">
                                                {get('modals.download')}
                                            </Button>
                                            {file.from_app ? (
                                                <p style={{ display: 'inline', marginLeft: '15px', color: 'red' }}>
                                                    <strong>
                                                        For internal reference only. No workflow for production team.
                                                    </strong>
                                                </p>
                                            ) : (
                                                ''
                                            )}
                                            <hr />
                                        </div>

                                        <Grid container>
                                            {photos.map(
                                                ([key, value], tPhotoIndex) =>
                                                    value && (
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            sm={6}
                                                            md={4}
                                                            key={`case-file-photo-t-l-${key}-${tPhotoIndex}`}
                                                            style={{ padding: 8, textAlign: 'center' }}
                                                        >
                                                            <Zoom zoomMargin={48}>
                                                                <img
                                                                    src={join(ApiServerUrl, value)}
                                                                    style={{
                                                                        maxHeight: 300,
                                                                        width: 'auto',
                                                                        marginLeft: 'auto',
                                                                        marginRight: 'auto',
                                                                        maxWidth: '100%',
                                                                    }}
                                                                />
                                                            </Zoom>
                                                        </Grid>
                                                    )
                                            )}
                                        </Grid>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </Grid>
                </Grid>
            </div>
        </>
    );
};

export default Photos;
